import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layout-atention" }
const _hoisted_2 = ["innerHTML"]

import { ref, onMounted } from 'vue';
import useAtention from '@/composables/useAtention'


export default /*#__PURE__*/_defineComponent({
  props: ['content', 'pos'],
  setup(__props) {

const props = __props



let { content, show, pos } = useAtention()

// onMounted(() => {
//   if (props.articleID) {
//     fetchContent()
//   }
// })


return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      innerHTML: _unref(content),
      id: "layout-atention-dialog",
      style: _normalizeStyle({ top: _unref(pos).y + 'px', left: _unref(pos).x + 'px' })
    }, null, 12, _hoisted_2)
  ], 512)), [
    [_vShow, _unref(show)]
  ])
}
}

})